import React from 'react'

type Props = {
    checked: boolean
    onChange: (value: boolean) => void
    disabled?: boolean
    label?: string
}

const Toggle = ({ checked, onChange, disabled, label }: Props) => (
    <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-accent/25 disabled:opacity-50 disabled:pointer-events-none ${checked ? 'bg-accent border-accent' : 'bg-categoriesTextColor/30 border-categoriesTextColor/20'}`}
    >
        <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-1 ring-black/5 transition-transform ${checked ? 'translate-x-[21px]' : 'translate-x-0.5'}`}
        />
    </button>
)

export default Toggle
